<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full-screen"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      no-padding
      :contentStyle="contentStyle"
      @close="cancel"
      @cancel="cancel"
      @confirm="confirm"
  >
    <span slot="header">分摊详情</span>

    <div slot="content" class="modal-main flex">
      <!--      左侧------------------------------------------------------------------------------------------------>
      <div class="modal-main-base">
        <div class="modal-main-header size12 color333 weigh600" style="display: flex;align-items: center">
          <span style="display: inline-block;width: 4px;height: 14px;background-color: #1F6EEF;margin-right: 8px"></span>
          <span>基本信息</span>
        </div>
        <div class="modal-main-base-info">
          <div class="modal-main-base-info-tip flex align-center size12">
            <i class="el-icon-warning colorBlue"></i>
            同一个费用项需要一次性分摊完。
          </div>
          <div class="size12 color333 weigh600" style="padding: 16px 0;">{{ form.marketName }}：{{ param.countryId }}
          </div>
          <div class="size12 color333"><span class="weigh600">费用名称：</span>{{ param.feeName }}</div>

          <div class="expense-list">
            <el-tooltip v-for="(i,index) in row.fee" :content="i.desc" :key="i.desc" popper-class="tooltip"
                        placement="right">
              <el-button class="expense-item text-ellipsis-1 size12"
                         :class="{'expense-item-active':expenseActive===index,'weigh600':expenseActive===index,'noSet':!i.canSet}"
                         @click="expenseActive=index">
                <gj-text max-width="95%">{{ i.desc }}</gj-text>
              </el-button>
            </el-tooltip>
          </div>

          <div class="size12">
            <span class="color999">已完成分摊：</span>
            <span class="color333">{{ ssNum }}/{{ row.fee.length }}</span>
          </div>
        </div>
      </div>

      <!--      中间--------------------------------------------------------------------------------------------------->
      <div class="modal-main-asin">
        <div class="modal-main-header size12 weigh600 color333 flex align-center">
          <span class="weigh600" style="min-width: 110px;display: flex;align-items: center">
            <span style="display: inline-block;width: 4px;height: 14px;background-color: #1F6EEF;margin-right: 8px"></span>
            <span>分摊ASIN</span>
          </span>
          <span class="color999 flex align-center"><span style="color: #EA4D4D;">*</span>分摊日期：</span>
          <gj-date-picker v-model="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          :clearable="false"
                          range-separator="至"
                          :disabled-date="disabledDate"
                          @input="changeDatePicker"
                          class="cost-picker"
                          ref="costPicker"
          >
          </gj-date-picker>
          <i class="el-icon-arrow-down" @click="$refs.costPicker.pickerFocus()"></i>
          <span class="size12 color333" style="padding-left: 40px;min-width: 120px;text-align: right;">
            <span class="weigh600 color999">分摊金额：</span>${{ row.fee[expenseActive].feeAmount }}
          </span>
        </div>
        <el-tabs v-model="activeName">
          <!--          已选tab------------------------------------------------------------------------------------------------>
          <el-tab-pane name="select">
            <span slot="label">已选择ASIN {{ dataSelect.length }}</span>
            <gj-table
                ref="selectTable"
                :data="dataSelect"
                :columns="columnsSelect"
                size="has-picture"
                selection
                :index="false"
                :highlightCurrentRow="true"
                :offsetHeight="60"
                @selection-change="clickItem"
                @current-change="currentChange"
            >
              <template v-slot:title="{ row }">
                <div class="text-ellipsis-1 size12">{{ row.title }}</div>
                <div class="flex size12">
                  <span class="colorBlue" style="padding-right: 20px;">
                    <a :href="row.asinUrl" target="_blank">{{row.asin}}</a>
                  </span>
                  <span>{{ row.msku }}</span>
                </div>
              </template>
              <template v-slot:date>
                {{ date[0].slice(5, 10).replace(/-/g, '/') }}-{{ date[1].slice(5, 10).replace(/-/g, '/') }}
              </template>

              <template v-slot:salesMoneyTotal="{row}">
                {{ row.currencySymbol }}{{ row.salesMoneyTotal }}
              </template>

              <template v-slot:shareMoneyTotal="{row}">
                <gj-input v-model="row.shareMoneyTotal" width="120px" placeholder="" :clearable="false"
                          :disabled="true">
                  <template slot="prepend">{{ row.currencySymbol }}</template>
                </gj-input>
              </template>

              <template v-slot:footer>
                <div class="modal-main-asin-footer flex align-center justify-between">
                  <gj-button class="deleBtn size12" :class="{'delBtn1':dataSelectSelect.length>0}" size="mini" plain
                             :disabled="dataSelectSelect.length === 0"
                             @click="deleteSelect">移除
                  </gj-button>

                  <div class="size12">
                    <span style="color: #DE3232;" v-if="row.fee[expenseActive].diff&&row.fee[expenseActive].diff!==0">（差额：{{
                        row.fee[expenseActive].currencySymbol
                      }}{{ row.fee[expenseActive].diff }}）</span>
                    <span class="color333" style="font-weight: 600;">总计：{{ row.fee[expenseActive].currencySymbol }}{{
                        row.fee[expenseActive].sum
                      }}</span>
                  </div>

                </div>
              </template>
              <template v-slot:empty v-if="dataSelect.length===0">
                <div class="flex align-center justify-center size12 color999" style="padding-top: 150px;">
                  暂无分摊ASIN，请先切换到全部ASIN去
                  <gj-button style="padding: 0 0 0 5px;" type="text" @click="activeName='all'">添加</gj-button>
                </div>
              </template>
            </gj-table>
          </el-tab-pane>
          <!--          全部tab------------------------------------------------------------------------------------------------>
          <el-tab-pane name="all">
            <span slot="label">全部ASIN</span>
            <div class="select-box">
              <gj-select-input
                  v-model="selectVal"
                  :options="saleOrderDynKey"
                  :width="['90px', '200px']"
                  @blur="searchInput"
                  @confirm="searchInput"
              >
              </gj-select-input>
            </div>
            <gj-table
                class="all-select"
                ref="allTable"
                :loading="loading"
                :data="dataAll"
                :columns="columnsAll"
                size="has-picture"
                :index="false"
                :offsetHeight="60"
                :pagination="pagination"
                :pagination-option="{small: true, background: false, layout: 'total, prev, pager, next, sizes'}"
                @page-change="$gjNoticeQuery"
            >

              <template v-slot:header:op>
                <gj-button
                    type="text"
                    :loading="allLoad"
                    @click="addThis('all')"
                >添加全部
                </gj-button>
              </template>

              <template v-slot:op="{row}">
                <gj-button
                    size="mini"
                    type="text"
                    style="border: none"
                    :loading="(row.isLoad||allLoad)&&!row.isChoose"
                    :disabled="row.isChoose"
                    @click="addThis('one',row)"
                >添加
                </gj-button>
              </template>

              <template v-slot:msku="{ row }">
                <div>{{ row.msku }}</div>
                <div>{{ row.asin }}</div>
              </template>
            </gj-table>
          </el-tab-pane>

        </el-tabs>
      </div>

      <!--      右侧------------------------------------------------------------------------------------------------>
      <div class="modal-main-list">
        <div class="modal-main-header size12 color333">
          <div class="weigh600" style="width: 100px;display: flex;align-items: center">
            <span style="display: inline-block;width: 4px;height: 14px;background-color: #1F6EEF;margin-right: 8px"></span>
            <span>分摊明细</span>
          </div>
        </div>
        <div class="modal-main-list-info size12 color666 flex align-center" v-if="dataDetail">
          <span style="padding-right: 20px;">ASIN：{{ dataDetail.asin }}</span>
          <span>MSKU：{{ dataDetail.msku }}</span>
        </div>
        <div class="tableOut" v-if="dataDetail">
          <gj-table
              :data="dataDetail.shareDetails"
              :columns="columnsDetail"
              size="has-picture"
              :index="false"
              :offsetHeight="55"
          >
            <template v-slot:shareMoney="{row}">
              <gj-input width="120px" placeholder="" :clearable="false" v-model="row.shareMoney" v-number.toFixed2
                        @input="onInput($event,dataDetail)">
                <template slot="prepend">$</template>
              </gj-input>
            </template>
          </gj-table>
        </div>

      </div>
    </div>

  </gj-modal>
</template>

<script>
import {isMeaninglessMixin, modalMixIn, queryMixin} from "@/minxins";
import {endOfMonth, startOfMonth, format} from "date-fns";
import {isMeaningless} from "@/utils/common";
import {
  allAsin,//获取全部asin列表
} from '@/api/sale'
import {
  mskuSalesList,//获取msku的每日销售额
  saveFeeShare,//保存费用分摊
} from "@/api/finance";

export default {
  name: "cost-sharing-details-modal",
  mixins: [modalMixIn, queryMixin, isMeaninglessMixin],
  data() {
    return {
      confirmLoading: false,
      expenseActive: 0,//当前选中的费用描述
      ssNum: 0,//完成分摊的数量
      pagination: {currentPage: 1, pageSize: 20, total: 200,},//分页栏配置
      selectVal: {key: 'asin', value: null, popover: false},//搜索筛选项
      date: ['', ''],//日期选择结果
      contentStyle: {height: '100%'},//gj-modal主体样式
      activeName: 'select',//筛选tab选中
      //筛选框option
      saleOrderDynKey: [
        {id: 'asin', text: 'ASIN', moreShow: true},
        {id: 'sku', text: 'SKU', moreShow: true},
        {id: 'msku', text: 'MSKU', moreShow: true}
      ],

      allLoad: false,

      loading: false,
      //全部list
      dataAll: [],
      //全部list的唯一字段msku集合
      mskuAll: [],
      //全部list列字段配置
      columnsAll: [
        {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', width: '80px', style: {'padding-left': '20px'}},
        {id: 'msku', header: 'MSKU/ASIN', field: 'slot:msku', minWidth: '170px'},
        {id: 'sku', header: 'SKU', field: 'sku', minWidth: '146px',},
        {id: 'productName', header: '产品名称', field: 'productName', minWidth: '220px'},
        {id: 'op', header: 'slot:op', field: 'slot:op', width: '90'},
      ],

      //已选list
      dataSelect: [],
      //已选list的已选项集合
      dataSelectSelect: [],
      //已选list的唯一字段msku集合
      mskuSelect: [],
      //已选list列字段配置
      columnsSelect: [
        {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', width: '60px'},
        {id: 'title', header: '商品标题/ASIN/MSKU', field: 'slot:title', minWidth: '250px'},
        {id: 'date', header: '日期', field: 'slot:date', minWidth: '100px',},
        {id: 'salesMoneyTotal', header: '销售额', field: 'slot:salesMoneyTotal', minWidth: '85px',},
        {id: 'shareMoneyTotal', header: '分摊金额', field: 'slot:shareMoneyTotal', minWidth: '150px'},
      ],

      dataDetail: null,
      columnsDetail: [
        {id: 'date', header: '日期', field: 'date', minWidth: '60px'},
        {id: 'salesMoney', header: '销售额', field: 'salesMoney', minWidth: '100px', align: 'right'},
        {id: 'shareMoney', header: '分摊金额', field: 'slot:shareMoney', minWidth: '130px',}
      ],
      //日期禁用
      disabledDate: (date) => {
        let dateValue = new Date(this.param.feeShareMonth)
        const startOfMonthDate = startOfMonth(dateValue)
        const endOfMonthDate = endOfMonth(dateValue)
        return date < startOfMonthDate || date > endOfMonthDate
      }
    }
  },
  props: {
    //查询allList接口参数
    param: {
      type: Object,
      default: function () {
        return {
          countryId: '',//国家编码
          marketId: '',//店铺ID
          feeName: '',//费用名称
          feeShareMonth: '',//月份
        }
      }
    },
    //页面用信息
    form: {
      type: Object,
      default: function () {
        return {
          marketName: '',//店铺名称
        }
      }
    },
    row: {
      type: Object
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    //监控已选列表变化
    dataSelect: {
      handler(n, o) {
        //当前费用描述求合
        let num = 0;
        let data = this.row.fee[this.expenseActive];
        this.dataSelect.forEach(i => {
          num += i.shareMoneyTotal - 0;
        });
        data.sum = Math.round(num * 10000) / 10000;
        //当前费用描述差额
        data.diff = Math.round((data.sum - data.feeAmount) * 10000) / 10000;
        //费用描述是否已完成
        data.canSet = data.diff === 0 ? true : false;
        //费用描述已完成数
        this.ssNum = 0;
        this.row.fee.forEach(m => {
          if (m.canSet) {
            this.ssNum += 1;
          }
        })
        // this.setCostStatus();
        //已选list的msku集合
        this.mskuSelect = this.dataSelect.map(i => {
          return i.msku
        })
        //已选list的asin集合
        this.row.fee[this.expenseActive].asins = this.dataSelect.map(i => {
          return i.asin
        })
        this.$forceUpdate();
      },
      deep: true,
      immediate: true
    },
    expenseActive: function (n, o) {
      //选中费用项改变时
      //已选列表改变
      this.dataSelect = this.row.fee[n].asinDetails;
      this.mskuSelect = this.dataSelect.map(i => {
        return i.msku
      })
      if (this.activeName === 'all') {
        this.setChoose();
      }
      //时间改变
      this.dateHandle(this.row.fee[n].feeDateStart, this.row.fee[n].feeDateEnd, this.row.fee[n]);
      //高亮第一行
      this.setHighlight(n);
    },
    activeName: function (n, o) {
      if (n === 'all') {
        this.setChoose();
      }
    }
  },
  methods: {
    //初始化页面
    init() {
      //初始化已选时间
      this.dateHandle(this.row.fee[0].feeDateStart, this.row.fee[0].feeDateEnd, this.row.fee[0]);
      //初始化已选列表
      this.dataSelect = this.row.fee[0].asinDetails;
      //高亮第一行
      this.setHighlight(0);

      this.setCostStatus();
      // this.dataSelect.length === 0 ? this.activeName = 'all' : this.activeName = 'select';
    },
    //获取每个费用描述已分摊状态
    setCostStatus() {
      this.row.fee.forEach(m => {
        let num = 0;
        m.asinDetails.forEach(i => {
          num += i.shareMoneyTotal - 0;
        });
        m.sum = Math.round(num * 10000) / 10000;
        //当前费用描述差额
        m.diff = Math.round((m.sum - m.feeAmount) * 10000) / 10000;
        m.canSet = m.diff === 0 ? true : false;
        if (m.canSet) {
          this.ssNum += 1;
        }
      })
    },
    //设置高两行及右侧列表
    setHighlight(n) {
      if (this.dataSelect.length > 0) {
        let setTime = setTimeout(() => {
          this.$refs.selectTable.$refs.gjTable.setCurrentRow(this.dataSelect[0]);
        }, 50);
        //右侧详情列表
        this.dataDetail = this.row.fee[n].asinDetails[0];
        this.$forceUpdate();
      } else {
        this.dataDetail = []
      }
    },
    //设置全部asin列表的选中状态
    setChoose() {
      this.dataAll.forEach(i => {
        i.isChoose = false;
      });
      this.mskuSelect.forEach(i => {
        let index = this.mskuAll.indexOf(i);
        if (index !== -1) {
          this.dataAll[index].isChoose = true;
        }
      })
    },
    //点击添加回调
    addThis(type, row) {
      //需添加到已选list的列表
      let addArr = [];
      let mskuArr = [];
      //单添加
      if (type === 'one') {
        addArr = [row];
        mskuArr = [row.msku];
        row.isLoad = true;
      }
      //全部添加
      else {
        this.allLoad = true;
        this.dataAll.forEach((i, index) => {
          if (!i.isChoose) {
            addArr.push(i)
            mskuArr.push(i.msku)
          }
        });
      }
      this.addToSelect(mskuArr, addArr, 'add', row);
    },
    //时间切换回调
    changeDatePicker(time) {
      this.row.fee[this.expenseActive].feeDateStart = time[0];
      this.row.fee[this.expenseActive].feeDateEnd = time[1];
      this.addToSelect(this.mskuSelect, this.dataSelect, 'reset')
    },
    //添加选中项到dataSelect
    addToSelect(mskuArr, addArr, type = 'add', row) {
      let param = {
        dateStart: this.date[0],
        dateEnd: this.date[1],
        marketId: this.param.marketId,
        msku: mskuArr
      };
      mskuSalesList(param).then(data => {
        //插入行到已选数据列表
        if (type === 'add') {
          addArr.forEach(o => {
            data.data.forEach((i, index) => {
              if (i.msku === o.msku) {
                let m = {
                  salesMoneyTotal: i.salesMoneyTotal,
                  shareMoneyTotal: i.shareMoneyTotal,
                  currencySymbol: this.row.fee[this.expenseActive].currencySymbol,
                  shareDetails: i.shareDetails,
                  ...o
                };
                this.dataSelect.push(m);
                o.isChoose = true;
              }
            })
          })
        }
        //更新已选数据销售额
        else {
          this.dataSelect.forEach((res, index) => {
            data.data.forEach(i => {
              if (res.msku === i.msku) {
                res.salesMoneyTotal = i.salesMoneyTotal;
                res.shareMoneyTotal = i.shareMoneyTotal;
                res.shareDetails = i.shareDetails;
              }
            })
          })
        }
      }).complete(() => {
        this.allLoad = false;
        if (row) {
          row.isLoad = false;
        }
      })
    },
    //搜索回调
    searchInput(val) {
      this.pagination.currentPage = 1;
      this.$gjQuery();
    },
    //初始化时间
    dateHandle(start, end, fee) {
      //若已有起始时间，填入时间组件
      if (start && end) {
        this.date = [start, end]
      }
      //若没有
      else {
        let d = new Date(this.param.feeShareMonth)
        // 用当月起始日期填入时间组件
        this.date = [
          format(startOfMonth(d), 'yyyy-MM-dd'),
          format(endOfMonth(d), 'yyyy-MM-dd')
        ];
        //用当月起始日期填入row
        fee.feeDateStart = format(startOfMonth(d), 'yyyy-MM-dd');
        fee.feeDateEnd = format(endOfMonth(d), 'yyyy-MM-dd');
      }
    },
    //修改值时回调
    onInput(val, row) {
      let num = 0;
      this.dataDetail.shareDetails.forEach(i => {
        num += i.shareMoney - 0;
      });
      this.dataDetail.shareMoneyTotal = Math.round(num * 10000) / 10000;
    },
    //点击已选list项 高亮
    currentChange(obj) {
      this.dataDetail = obj.row;
    },
    //删除所选项
    deleteSelect() {
      //清除已选list的勾选状态
      this.$refs.selectTable.$refs.gjTable.clearCheckboxRow();
      //遍历删除已选list的已选项，
      this.dataSelectSelect.forEach(i => {
        for (let m in this.dataSelect) {
          if (i.msku === this.dataSelect[m].msku) {
            this.dataSelect.splice(m, 1)
            break
          }
        }
      })
      //若已高亮选中
      if (this.$refs.selectTable.$refs.gjTable.getCurrentRecord()) {
        let activeMsku = this.$refs.selectTable.$refs.gjTable.getCurrentRecord().msku;
        //判断选中行是否在需删除列表中
        let m = this.dataSelectSelect.find(i => {
          return i.msku === activeMsku
        })
        //若选中高亮行不在需删除列表中,ruturn
        if (isMeaningless(m)) {
          //清空已选list的已选项集合
          this.dataSelectSelect = [];
          return
        }
      }
      //清空已选list的已选项集合
      this.dataSelectSelect = [];
      //否则，清空分摊详情
      this.dataDetail = ''

    },
    //已选列表勾选回调
    clickItem(data, index) {
      this.dataSelectSelect = data;
    },
    //获取AllList
    $gjQuery() {
      this.loading = true;
      let param = {
        current: this.pagination.currentPage,
        model: {
          marketId: this.param.marketId,
        },
        order: "descending",
        size: this.pagination.pageSize,
        sort: "id"
      };
      param.model[this.selectVal.key] = this.selectVal.value || '';
      allAsin(param).then(data => {
        this.pagination = this.getPagination(data);
        //获取全部list的msku列表
        this.mskuAll = data.records.map(i => {
          i.isLoad = false
          return i.msku
        })
        this.dataAll = data.records;
        //设置选中状态
        this.setChoose();
      }).complete(() => {
        this.loading = false;
      })
    },
    //取消
    cancel() {
      this.$emit("cancel");
      this.$gjDestroy();
    },
    //确定
    confirm() {
      if (this.row.fee[this.expenseActive].diff != 0) {
        this.$gjMessage.warning(`${this.row.feeName}分摊存在差异金额，请调整`)
        return
      } else {
        for (let i in this.row.fee) {
          if (this.row.fee[i].diff != 0) {
            this.$gjMessage.warning(`${this.row.feeName}分摊存在差异金额，请调整`);
            this.expenseActive = i - 0;
            this.dataSelect = this.row.fee[this.expenseActive].asinDetails;
            return
          }
        }
      }
      this.confirmLoading = true;
      saveFeeShare(this.row).then(data => {
        this.confirmLoading = false;
        this.$emit('submit');
        this.$gjMessage({
          message: '分摊已完成，数据将会在1小时内自动重算更新',
          iconClass: 'el-icon-warning colorBlue',
          customClass: 'successTip color666'
        });
        this.$gjDestroy();
      })
    }

  }
}
</script>

<style scoped lang="scss">
@import "../../../../../assets/styles/variables";
.weigh600 {
  font-weight: 600;
}

/deep/ .el-dialog__body {
  padding: 0;
}

.modal-main {
  height: 100%;

  /deep/ .el-input.is-disabled .el-input__inner {
    border-color: #D6D9DE;
    color: #333;
  }

  .modal-main-header {
    //width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    box-shadow: inset 0px -1px 0px 0px rgba(232, 233, 235, 1);

    .el-icon-arrow-down {
      line-height: 32px;
    }

    /deep/ .el-input__inner {
      border: none;
      padding: 3px 0;
      width: 180px !important;
    }

    /deep/ .el-range-separator {
      font-size: 12px;
      color: #999999;
      line-height: 26px;
      font-weight: 400;
      padding: 0 12px;
    }

    /deep/ .el-range__icon {
      display: none;
    }

    /deep/ .el-range__close-icon {
      display: none;
    }
  }

  //.size12 {
  //  font-weight: 600;
  //}

  .modal-main-base {
    width: 19%;
    min-width: 266px;
    flex: none;
    height: 100%;
    background: #F7F8FA;

    .modal-main-base-info {
      padding: 0 0 0 20px;

      .modal-main-base-info-tip {
        height: 40px;
        padding-left: 12px;
        background: #EDF7FF;
        border: 1px solid #9CCCFF;
        border-radius: 4px;
        margin: 12px 20px 0 0;
        color: #666666;

        .el-icon-warning {
          font-size: 18px;
          margin-right: 4px;
        }
      }

      .expense-list {
        margin: 12px 0 16px;
        max-height: 500px;
        overflow-y: auto;
        padding-right: 20px;

        .expense-item {
          border: none;
          margin: 0;
          background-color: transparent;
          box-sizing: border-box;
          padding: 12px;
          width: 100%;
          min-width: 220px;
          height: 44px;
          text-align: left;
          font-family: PingFangSC-Medium;
          position: relative;
        }

        .noSet:after {
          content: '';
          width: 6px;
          height: 6px;
          background: #F14444;
          border-radius: 50%;
          position: absolute;
          right: 5px;
          top: 5px;
        }

        .expense-item-active {
          background: #EBECEF;
          color: #1F6EEF;
        }
      }
    }
  }

  .modal-main-asin {
    flex: 1;
    border-right: 1px solid #E0E1E5;
    border-left: 1px solid #E0E1E5;
    border-bottom: 1px solid #E0E1E5;

    .all-select {
      /deep/ .vxe-header--column:nth-child(1) {
        padding-left: 20px !important;
      }

      /deep/ .vxe-body--column:nth-child(1) {
        padding-left: 20px !important;
      }
    }

    /deep/ .el-pagination {
      font-weight: normal;
    }

    /deep/ .el-input--mini .el-input__icon {
      line-height: 22px;
    }

    /deep/ .el-input--mini .el-input__inner {
      height: 22px;
      line-height: 22px;
      font-size: 12px;
    }

    /deep/ .row--current {
      height: 100%;
      position: relative;
    }

    /deep/ .row--current:after {
      content: '';
      position: absolute;
      height: 100%;
      width: 4px;
      background-color: #3168f0;
      left: 0;
    }

    /deep/ .vxe-table--render-default .vxe-body--row.row--current {
      background-color: $gj-check-bg;
    }

    /deep/ .vxe-table--render-default .vxe-body--row.row--hover.row--current {
      background-color: $gj-check-bg;
    }
    /deep/ .el-tabs__nav-wrap{
      margin-bottom: 0;

    }

    /deep/ .el-tabs__nav-wrap::after {
      height: 1px;
    }

    /deep/ .el-tabs__nav-scroll {
      padding-left: 20px;
    }

    /deep/ .el-tabs__header {
      margin: 0
    }

    /deep/ .el-tabs__item {
      color: #999;
      font-size: 12px;
      font-weight: 400;
    }

    /deep/ .el-tabs__item.is-active {
      color: #1F6EEF;
      font-weight: 600
    }

    .select-box {
      padding: 12px 16px;
      border-bottom: 1px solid #F2F1F1;
    }

    /deep/ .gj-footer-content{
      background-color: #FFFFFF;
      border: none;
      transform: translateY(10px);
      width: 100%;
      position: absolute;
    }
    .modal-main-asin-footer {
      height: 28px;
      padding: 0 63px 0 16px;
      border: none;


      .delBtn1 {
        color: #3168F0;
        border-color: #3168F0;
      }
    }
  }

  .modal-main-list {
    width: 25%;
    min-width: 350px;
    flex: none;

    .modal-main-list-info {
      padding: 12px 0 12px 20px;
    }

    .tableOut{
      margin:0 20px;
      border-bottom: 0;
    }
  }
}

/deep/ .gj-empty--description{
  font-size: 12px;
}
/deep/ .vxe-checkbox--checked-icon:before {
  background-color: #3168f0 !important;
}

/deep/ .vxe-checkbox--indeterminate-icon:before {
  background-color: #3168f0 !important;
}

/deep/ .vxe-table--body{
  width: 100%!important;
}

a:-webkit-any-link {
  color: #1F6EEF!important;
  -webkit-text-decoration-line: none;
  text-decoration-line: none;
}
/deep/ .el-tabs__item{
  padding: 0 16px;
}
/deep/ .modal-main .modal-main-asin .el-tabs__item{
   color: #666666;
 }
</style>
